import { render, staticRenderFns } from "./PageTabs.yaml?vue&type=template&id=e65996e4&component"
import script from "./PageTabs.yaml?vue&type=script&lang=ts&component"
export * from "./PageTabs.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports